import { render, staticRenderFns } from "./OrdenesRealizadas.vue?vue&type=template&id=dd3d3080"
import script from "./OrdenesRealizadas.vue?vue&type=script&lang=ts"
export * from "./OrdenesRealizadas.vue?vue&type=script&lang=ts"
import style0 from "./OrdenesRealizadas.vue?vue&type=style&index=0&id=dd3d3080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports